export interface LayerAgent {
  id: string;
  index: string;
  name: string;
  layer: string;
  role: string;
  mandate: string;
  image: string;
  hair: string;
  hairLength: "long" | "shoulder";
  accent: string;
}

export const layerAgents: LayerAgent[] = [
  {
    id: "interface-lead",
    index: "01",
    name: "LIN",
    layer: "Interface",
    role: "Interface Architect",
    mandate: "Own the human-facing surface: semantics, accessibility, responsiveness and browser behavior.",
    image: "/assets/layer-agents/interface-lead-v1.png",
    hair: "Natural black",
    hairLength: "long",
    accent: "#151717",
  },
  {
    id: "frontend-lead",
    index: "02",
    name: "YAO",
    layer: "Frontend",
    role: "Frontend Composer",
    mandate: "Coordinate typed components, routes, client state and data-fetching boundaries.",
    image: "/assets/layer-agents/frontend-lead-v1.png",
    hair: "Cobalt blue",
    hairLength: "long",
    accent: "#1646d8",
  },
  {
    id: "boundary-lead",
    index: "03",
    name: "RUI",
    layer: "Boundary",
    role: "Contract Guardian",
    mandate: "Defend every crossing with explicit protocols, schemas, validation and identity rules.",
    image: "/assets/layer-agents/boundary-lead-v1.png",
    hair: "Silver",
    hairLength: "shoulder",
    accent: "#8f959c",
  },
  {
    id: "backend-lead",
    index: "04",
    name: "NING",
    layer: "Backend",
    role: "Runtime Operator",
    mandate: "Own server execution, service composition, repositories and measured runtime choices.",
    image: "/assets/layer-agents/backend-lead-v1.png",
    hair: "Burgundy",
    hairLength: "long",
    accent: "#7b2438",
  },
  {
    id: "data-lead",
    index: "05",
    name: "LAN",
    layer: "Data",
    role: "Data Curator",
    mandate: "Own durable models, schemas, queries, storage decisions and data integrity.",
    image: "/assets/layer-agents/data-lead-v1.png",
    hair: "Platinum white",
    hairLength: "long",
    accent: "#dce7ee",
  },
  {
    id: "intelligence-lead",
    index: "06",
    name: "ZHI",
    layer: "Intelligence",
    role: "Intelligence Strategist",
    mandate: "Govern models, retrieval, agents, tool use and evidence-gated evaluation.",
    image: "/assets/layer-agents/intelligence-lead-v1.png",
    hair: "Violet",
    hairLength: "long",
    accent: "#7550a6",
  },
  {
    id: "systems-lead",
    index: "07",
    name: "QING",
    layer: "Systems",
    role: "Systems Engineer",
    mandate: "Expose memory, ownership, concurrency, profiling and physical performance costs.",
    image: "/assets/layer-agents/systems-lead-v1.png",
    hair: "Teal",
    hairLength: "shoulder",
    accent: "#00838a",
  },
  {
    id: "production-lead",
    index: "08",
    name: "JIN",
    layer: "Production",
    role: "Release Commander",
    mandate: "Own versioning, collaboration, CI, deployment, security and release evidence.",
    image: "/assets/layer-agents/production-lead-v1.png",
    hair: "Copper gold",
    hairLength: "long",
    accent: "#b7652c",
  },
  {
    id: "feedback-lead",
    index: "09",
    name: "MO",
    layer: "Feedback",
    role: "Feedback Analyst",
    mandate: "Turn logs, benchmarks and observed outcomes into the next bounded learning action.",
    image: "/assets/layer-agents/feedback-lead-v1.png",
    hair: "Rose pink",
    hairLength: "shoulder",
    accent: "#c76378",
  },
];

export function layerAgentFor(layer: string) {
  return layerAgents.find((agent) => agent.layer === layer);
}

export function layerAgentById(id: string) {
  return layerAgents.find((agent) => agent.id === id);
}
